import React from "react";
import "./DashBoardStyle.css";
import Button from "../../components/globalComponents/buttons/primaryButton/PrimaryButton";
import ProgressBar from "../../components/globalComponents/progressBar/ProgressBar";
// import Buttons from "../../components/globalComponents/buttons/Buttons";

import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  lmsSliceData,
  getCourseByStudentId,
  getStuCourseAttendance,
  getCourseForStudentCalendar,
  getUpcomingAssignmentsAndQuiz,clearState2
} from "../../reducers/lmsSlice";
import {
  getAllAnnouncements,
  announcementSliceFunction,
} from "../../reducers/announcementSlice";
import { useEffect, useState } from "react";
import PageLoader from "../../components/globalComponents/PageLoader/PageLoader";
import { useNavigate } from "react-router-dom";
import AnnouncementPopup from "../../components/popups/announcementPopup/AnnouncementPopup";

const localizer = momentLocalizer(moment);

const DashBoard = () => {
  const dispatch = useDispatch();
  const {
    // isSuccess,
    isFetching,
    getStudentCourseData,
    getStudentCourseAttendance,
    calanderData,
    getUpcomingAnnoucements,coursesFetched
  } = useSelector(lmsSliceData);

  // const [getLmsAllData, setGetLmsAllData] = useState([]);
  const [category, setCategory] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [announcementToggler, setAnnouncementToggler] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState([]);

  // Call APi
  useEffect(() => {
    dispatch(getStuCourseAttendance());
    dispatch(getCourseByStudentId());
    dispatch(getAllAnnouncements());
    dispatch(getUpcomingAssignmentsAndQuiz());
    // eslint-disable-next-line
  }, []);
  useEffect(()=>{
    if( coursesFetched){
      dispatch(clearState2())
    }
  },[coursesFetched])

  const { announcementData, announcementFetching } = useSelector(
    announcementSliceFunction
  );
  const navigate = useNavigate();

  // Calander Data
  let eventList = [];
  calanderData?.length > 0 &&
    calanderData?.forEach((ele) => {
      ele?.CourseSessions.forEach((data) => {
        let y = parseInt(moment(data?.date).format("YYYY")); // Year
        let m = parseInt(moment(data?.date).format("MM") - 1); // Month
        let d = parseInt(moment(data?.date).format("DD")); // date
        let sh = parseInt(data?.fromTime.substr(0, 2)); //start hours
        let sm = parseInt(data?.fromTime.substr(3));
        let eh = parseInt(data?.toTime.substr(0, 2));
        let em = parseInt(data?.fromTime.substr(3));
        let obj = {
          title: data.name,
          start: new Date(y, m, d, sh, sm),
          end: new Date(y, m, d, eh, em),
        };
        // console.log(new Date(y, m, d, sh, sm), "objjj")
        eventList?.push(obj);
      });
    });

  console.log(eventList, "eventList");

  //  All Session Length
  let allSession =
    getStudentCourseData?.length > 0 &&
    getStudentCourseData
      ?.map((res) => res.CourseRoster)
      .flatMap(({ CourseSessions }) => CourseSessions);

  // Percentage
  const getPercentage = (res) => {
    let data =
      res?.totalSessionHeldCount === 0
        ? 0
        : (res?.sessionAttendend / res?.totalSessionHeldCount) * 100;
    return data?.toFixed(2);
  };

  function removeTags(str) {
    if (!str) return false;
    else str = str.toString();

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, "");
  }

  const categoryHandleChange = (e) => {
    const { value } = e.target;
    if (category.includes(value)) {
      const i = category.indexOf(value);
      let arr = category;
      arr.splice(i, 1);
      setCategory([...arr]);
    } else {
      setCategory((prev) => [...prev, value]);
    }
    setConfirm(true);
  };

  useEffect(() => {
    // if (check) {
    let obj = {
      courseIdArray: category,
    };
    if (confirm) {
      dispatch(getCourseForStudentCalendar(obj));
      setConfirm(false);
    }
    // eslint-disable-next-line
  }, [category]);

  useEffect(() => {
    if (getStudentCourseData?.length > 0 && category.length === 0) {
      const data = getStudentCourseData?.map((res) => res.CourseRoster.id);
      setCategory(data);
      let obj = {
        courseIdArray: data,
      };
      dispatch(getCourseForStudentCalendar(obj));
    }
    // eslint-disable-next-line
  }, [getStudentCourseData]);

  const handleAnnouncmentClick = (index) => {
    setSelectedAnnouncement(announcementData[index]);
    setAnnouncementToggler(true);
  };

  return (
    <>
      {(isFetching || announcementFetching) && <PageLoader />}

      <AnnouncementPopup
        isOpen={announcementToggler}
        setIsOpen={setAnnouncementToggler}
        data={selectedAnnouncement}
      />
      <div className="main-wrapper">
        <div className="dashboard-left">
          <div className="session-wrapper">
            <div
              className="session-box"
              onClick={() => navigate("/myCourses", { exact: true })}
            >
              <span className="session-heading">All Courses</span>
              <span className="session-count">
                {getStudentCourseData?.length}
              </span>
              <p className="session-more">
                View more
                <svg
                  width="12"
                  height="10"
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.10225 0.852252C1.32192 0.632583 1.67808 0.632583 1.89775 0.852252L5.64775 4.60225C5.86742 4.82192 5.86742 5.17808 5.64775 5.39775L1.89775 9.14775C1.67808 9.36742 1.32192 9.36742 1.10225 9.14775C0.882583 8.92808 0.882583 8.57192 1.10225 8.35225L4.4545 5L1.10225 1.64775C0.882583 1.42808 0.882583 1.07192 1.10225 0.852252ZM6.35225 0.852252C6.57192 0.632583 6.92808 0.632583 7.14775 0.852252L10.8977 4.60225C11.1174 4.82192 11.1174 5.17808 10.8977 5.39775L7.14775 9.14775C6.92808 9.36742 6.57192 9.36742 6.35225 9.14775C6.13258 8.92808 6.13258 8.57192 6.35225 8.35225L9.7045 5L6.35225 1.64775C6.13258 1.42808 6.13258 1.07192 6.35225 0.852252Z"
                    fill="#006CD4"
                  />
                </svg>
              </p>
            </div>

            <div className="session-box green-session">
              <span className="session-heading">All Sessions</span>
              <span className="session-count">{allSession?.length}</span>
              <p className="session-more">
                {/* View more
                <svg
                  width="12"
                  height="10"
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.10225 0.852252C1.32192 0.632583 1.67808 0.632583 1.89775 0.852252L5.64775 4.60225C5.86742 4.82192 5.86742 5.17808 5.64775 5.39775L1.89775 9.14775C1.67808 9.36742 1.32192 9.36742 1.10225 9.14775C0.882583 8.92808 0.882583 8.57192 1.10225 8.35225L4.4545 5L1.10225 1.64775C0.882583 1.42808 0.882583 1.07192 1.10225 0.852252ZM6.35225 0.852252C6.57192 0.632583 6.92808 0.632583 7.14775 0.852252L10.8977 4.60225C11.1174 4.82192 11.1174 5.17808 10.8977 5.39775L7.14775 9.14775C6.92808 9.36742 6.57192 9.36742 6.35225 9.14775C6.13258 8.92808 6.13258 8.57192 6.35225 8.35225L9.7045 5L6.35225 1.64775C6.13258 1.42808 6.13258 1.07192 6.35225 0.852252Z"
                    fill="#1C7C54"
                  />
                </svg> */}
              </p>
            </div>
          </div>

          <div className="process-wrapper mt-10">
            <div className="process-heading">
              <p className="dash-heading-small">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.5 1.875C2.84518 1.875 3.125 2.15482 3.125 2.5V16.1667C3.125 16.4103 3.12549 16.5555 3.13428 16.6631C3.13965 16.7288 3.14673 16.7564 3.14902 16.7638C3.16862 16.801 3.19902 16.8314 3.23622 16.851C3.24361 16.8533 3.27122 16.8604 3.3369 16.8657C3.4445 16.8745 3.58967 16.875 3.83334 16.875H17.5C17.8452 16.875 18.125 17.1548 18.125 17.5C18.125 17.8452 17.8452 18.125 17.5 18.125H3.81148C3.59691 18.125 3.39984 18.125 3.23511 18.1116C3.0575 18.0971 2.86319 18.0638 2.67127 17.9661C2.39686 17.8262 2.17377 17.6031 2.03395 17.3287C1.93616 17.1368 1.90294 16.9425 1.88843 16.7649C1.87497 16.6002 1.87499 16.4031 1.875 16.1885L1.875 2.5C1.875 2.15482 2.15482 1.875 2.5 1.875ZM3.23406 16.8502C3.23409 16.8502 3.23453 16.8504 3.23531 16.8507L3.23406 16.8502ZM3.14977 16.7659C3.14977 16.766 3.14961 16.7656 3.14932 16.7647L3.14977 16.7659ZM17.094 6.21058C17.3459 6.44658 17.3588 6.8421 17.1228 7.09399L13.857 10.5795C13.849 10.5881 13.8403 10.5975 13.831 10.6076C13.7416 10.7046 13.5943 10.8643 13.4006 10.9529C13.2358 11.0282 13.0543 11.0593 12.8739 11.043C12.6617 11.0239 12.4697 10.9223 12.3531 10.8606C12.341 10.8542 12.3297 10.8482 12.3192 10.8427L9.60476 9.43329C9.59485 9.42815 9.58554 9.42331 9.57674 9.41875C9.56996 9.42598 9.56278 9.43364 9.55515 9.44178L6.28942 12.9273C6.05342 13.1792 5.6579 13.1921 5.40601 12.9561C5.15412 12.7201 5.14124 12.3246 5.37725 12.0727L8.64297 8.58713C8.65101 8.57855 8.65969 8.56913 8.669 8.55904C8.75844 8.46206 8.9057 8.30237 9.09945 8.21378C9.26418 8.13845 9.44571 8.10738 9.62612 8.12363C9.8383 8.14275 10.0303 8.24437 10.1469 8.30609C10.159 8.31251 10.1703 8.3185 10.1808 8.32392L12.8952 9.73338C12.9052 9.73852 12.9145 9.74335 12.9233 9.74792C12.9301 9.74069 12.9372 9.73303 12.9449 9.72489L16.2106 6.23934C16.4466 5.98745 16.8421 5.97457 17.094 6.21058Z"
                    fill="#262626"
                  />
                </svg>
                My Progress
              </p>
            </div>

            <div className="process-body">
              <ul className="process-list">
                {getStudentCourseData?.length > 0 &&
                  getStudentCourseData?.map((res, i) => (
                    <li key={i}>
                      <div className="process-list-main">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                            fill="#006CD4"
                          />
                        </svg>
                        {res?.CourseRoster?.courseName}
                      </div>
                      {/* <span className="process-status">In Progress</span> */}

                      <div className="proress-menu">
                        <ul>
                          {res?.CourseRoster?.CourseSessions?.map(
                            (data, index) => (
                              <li
                                key={index}
                                className={`${
                                  data?.isCompleted ? "active" : ""
                                }`}
                                onClick={() =>
                                  navigate(
                                    `/courseDetails?courseId=${res.CourseRoster?.id}`,
                                    {
                                      exact: true,
                                    }
                                  )
                                }
                              >
                                <div className="process-menu-list pointer">
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                      fill="#006CD4"
                                    />
                                  </svg>
                                  {data?.name}
                                </div>
                                <span>
                                  <svg
                                    width="8"
                                    height="12"
                                    viewBox="0 0 8 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M1.05806 0.558058C1.30214 0.313981 1.69786 0.313981 1.94194 0.558058L6.94194 5.55806C7.18602 5.80214 7.18602 6.19786 6.94194 6.44194L1.94194 11.4419C1.69786 11.686 1.30214 11.686 1.05806 11.4419C0.813981 11.1979 0.813981 10.8021 1.05806 10.5581L5.61612 6L1.05806 1.44194C0.813981 1.19786 0.813981 0.802136 1.05806 0.558058Z"
                                      fill="#006CD4"
                                    />
                                  </svg>
                                </span>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    </li>
                  ))}
              </ul>
              {/* end */}
              {/* <ul className="process-list">
                          <li>
                            <div className="process-list-main">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                  fill="#006CD4"
                                />
                              </svg>
                              Fundamentals of Accounting
                            </div>
                            <span className="process-status active">View</span>
                          </li>
          
                          <li>
                            <div className="process-list-main">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                  fill="#006CD4"
                                />
                              </svg>
                              Fundamentals of Accounting
                            </div>
                            <span className="process-status">In Progress</span>
          
                            <div className="proress-menu">
                              <ul>
                                <li>
                                  <div className="process-menu-list">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                        fill="#006CD4"
                                      />
                                    </svg>
                                    Horizontal Analysis
                                  </div>
                                  <span>
                                    <svg
                                      width="8"
                                      height="12"
                                      viewBox="0 0 8 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M1.05806 0.558058C1.30214 0.313981 1.69786 0.313981 1.94194 0.558058L6.94194 5.55806C7.18602 5.80214 7.18602 6.19786 6.94194 6.44194L1.94194 11.4419C1.69786 11.686 1.30214 11.686 1.05806 11.4419C0.813981 11.1979 0.813981 10.8021 1.05806 10.5581L5.61612 6L1.05806 1.44194C0.813981 1.19786 0.813981 0.802136 1.05806 0.558058Z"
                                        fill="#006CD4"
                                      />
                                    </svg>
                                  </span>
                                </li>
          
                                <li>
                                  <div className="process-menu-list">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                        fill="#006CD4"
                                      />
                                    </svg>
                                    Vertical Analysis
                                  </div>
                                  <span>
                                    <svg
                                      width="8"
                                      height="12"
                                      viewBox="0 0 8 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M1.05806 0.558058C1.30214 0.313981 1.69786 0.313981 1.94194 0.558058L6.94194 5.55806C7.18602 5.80214 7.18602 6.19786 6.94194 6.44194L1.94194 11.4419C1.69786 11.686 1.30214 11.686 1.05806 11.4419C0.813981 11.1979 0.813981 10.8021 1.05806 10.5581L5.61612 6L1.05806 1.44194C0.813981 1.19786 0.813981 0.802136 1.05806 0.558058Z"
                                        fill="#006CD4"
                                      />
                                    </svg>
                                  </span>
                                </li>
          
                                <li>
                                  <div className="process-menu-list">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                        fill="#006CD4"
                                      />
                                    </svg>
                                    Trend Analysis
                                  </div>
                                  <span>
                                    <svg
                                      width="8"
                                      height="12"
                                      viewBox="0 0 8 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M1.05806 0.558058C1.30214 0.313981 1.69786 0.313981 1.94194 0.558058L6.94194 5.55806C7.18602 5.80214 7.18602 6.19786 6.94194 6.44194L1.94194 11.4419C1.69786 11.686 1.30214 11.686 1.05806 11.4419C0.813981 11.1979 0.813981 10.8021 1.05806 10.5581L5.61612 6L1.05806 1.44194C0.813981 1.19786 0.813981 0.802136 1.05806 0.558058Z"
                                        fill="#006CD4"
                                      />
                                    </svg>
                                  </span>
                                </li>
          
                                <li>
                                  <div className="process-menu-list">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                        fill="#006CD4"
                                      />
                                    </svg>
                                    iquidity Analysis
                                  </div>
                                  <span>
                                    <svg
                                      width="8"
                                      height="12"
                                      viewBox="0 0 8 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M1.05806 0.558058C1.30214 0.313981 1.69786 0.313981 1.94194 0.558058L6.94194 5.55806C7.18602 5.80214 7.18602 6.19786 6.94194 6.44194L1.94194 11.4419C1.69786 11.686 1.30214 11.686 1.05806 11.4419C0.813981 11.1979 0.813981 10.8021 1.05806 10.5581L5.61612 6L1.05806 1.44194C0.813981 1.19786 0.813981 0.802136 1.05806 0.558058Z"
                                        fill="#006CD4"
                                      />
                                    </svg>
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </li>
          
                          <li>
                            <div className="process-list-main">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                  fill="#006CD4"
                                />
                              </svg>
                              Fundamentals of Accounting
                            </div>
                            <span className="process-status">Pending</span>
                          </li>
          
                          <li>
                            <div className="process-list-main">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303L6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697C7.26256 11.1768 7.73744 11.1768 8.03033 11.4697L10.5 13.9393L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z"
                                  fill="#006CD4"
                                />
                              </svg>
                              Fundamentals of Accounting
                            </div>
                            <span className="process-status">Pending</span>
                          </li>
                        </ul> */}
            </div>
          </div>

          <div className="assignment-wrapper mt-10">
            <div className="process-heading">
              <p className="dash-heading-small">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.30799 1.875L4.69419 1.875C5.60431 1.875 6.32556 1.87499 6.90691 1.92249C7.5014 1.97106 8.00442 2.0724 8.46373 2.30643C9.09247 2.62679 9.62197 3.10823 10 3.69855C10.3781 3.10823 10.9076 2.62679 11.5363 2.30643C11.9956 2.0724 12.4986 1.97106 13.0931 1.92249C13.6745 1.87499 14.3957 1.875 15.3059 1.875L15.692 1.875C16.1372 1.87499 16.5087 1.87498 16.8122 1.89978C17.1288 1.92565 17.426 1.98157 17.7071 2.12478C18.1383 2.34449 18.4889 2.69507 18.7086 3.12627C18.8518 3.40732 18.9077 3.70454 18.9336 4.02111C18.9584 4.32463 18.9584 4.69617 18.9584 5.14129V12.3587C18.9584 12.8038 18.9584 13.1754 18.9336 13.4789C18.9077 13.7955 18.8518 14.0927 18.7086 14.3737C18.4889 14.8049 18.1383 15.1555 17.7071 15.3752C17.426 15.5184 17.1288 15.5744 16.8122 15.6002C16.5087 15.625 16.1372 15.625 15.6921 15.625H14.521C13.4385 15.625 13.0275 15.6314 12.6636 15.7419C12.323 15.8453 12.006 16.0149 11.731 16.241C11.4372 16.4825 11.2039 16.8209 10.6034 17.7216L10.5201 17.8467C10.4041 18.0206 10.209 18.125 10 18.125C9.79105 18.125 9.59591 18.0206 9.47999 17.8467L9.39661 17.7216C8.79615 16.8209 8.56286 16.4825 8.26909 16.241C7.99403 16.0149 7.67709 15.8453 7.33641 15.7419C6.97255 15.6314 6.56153 15.625 5.47904 15.625H4.30798C3.86286 15.625 3.49132 15.625 3.1878 15.6002C2.87123 15.5744 2.57401 15.5184 2.29296 15.3752C1.86175 15.1555 1.51117 14.8049 1.29146 14.3737C1.14826 14.0927 1.09234 13.7955 1.06647 13.4789C1.04167 13.1754 1.04168 12.8038 1.04169 12.3587V5.1413C1.04168 4.69618 1.04167 4.32464 1.06647 4.02111C1.09234 3.70454 1.14826 3.40732 1.29146 3.12627C1.51117 2.69507 1.86175 2.34449 2.29296 2.12478C2.57401 1.98157 2.87123 1.92565 3.1878 1.89978C3.49132 1.87498 3.86286 1.87499 4.30799 1.875ZM9.37502 7.83333C9.37502 6.8896 9.37453 6.21939 9.33168 5.6949C9.28943 5.17771 9.20911 4.8575 9.07983 4.60378C8.82017 4.09417 8.40585 3.67985 7.89625 3.42019C7.64252 3.29091 7.32231 3.2106 6.80512 3.16834C6.28063 3.12549 5.61042 3.125 4.66669 3.125H4.33335C3.85633 3.125 3.53615 3.12549 3.28959 3.14563C3.05032 3.16518 2.93591 3.20008 2.86045 3.23854C2.66445 3.3384 2.50509 3.49776 2.40522 3.69376C2.36677 3.76923 2.33187 3.88363 2.31232 4.1229C2.29217 4.36946 2.29169 4.68964 2.29169 5.16667V12.3333C2.29169 12.8104 2.29217 13.1305 2.31232 13.3771C2.33187 13.6164 2.36677 13.7308 2.40522 13.8062C2.50509 14.0022 2.66445 14.1616 2.86045 14.2615C2.93591 14.2999 3.05032 14.3348 3.28959 14.3544C3.53615 14.3745 3.85633 14.375 4.33335 14.375H5.47904C5.51314 14.375 5.54681 14.375 5.58006 14.375C6.52657 14.3748 7.13604 14.3746 7.69964 14.5458C8.19756 14.697 8.66078 14.9449 9.06279 15.2753C9.17223 15.3653 9.2749 15.4629 9.37502 15.5703V7.83333ZM10.625 15.5703C10.7251 15.4629 10.8278 15.3653 10.9373 15.2753C11.3393 14.9449 11.8025 14.697 12.3004 14.5458C12.864 14.3746 13.4735 14.3748 14.42 14.375C14.4532 14.375 14.4869 14.375 14.521 14.375H15.6667C16.1437 14.375 16.4639 14.3745 16.7105 14.3544C16.9497 14.3348 17.0641 14.2999 17.1396 14.2615C17.3356 14.1616 17.4949 14.0022 17.5948 13.8062C17.6333 13.7308 17.6682 13.6164 17.6877 13.3771C17.7079 13.1305 17.7084 12.8104 17.7084 12.3333V5.16667C17.7084 4.68964 17.7079 4.36946 17.6877 4.1229C17.6682 3.88363 17.6333 3.76923 17.5948 3.69376C17.4949 3.49776 17.3356 3.3384 17.1396 3.23854C17.0641 3.20008 16.9497 3.16518 16.7105 3.14563C16.4639 3.12549 16.1437 3.125 15.6667 3.125H15.3334C14.3896 3.125 13.7194 3.12549 13.1949 3.16834C12.6777 3.2106 12.3575 3.29091 12.1038 3.42019C11.5942 3.67985 11.1799 4.09417 10.9202 4.60378C10.7909 4.8575 10.7106 5.17771 10.6684 5.6949C10.6255 6.21939 10.625 6.8896 10.625 7.83333V15.5703Z"
                    fill="#262626"
                  />
                </svg>
                Upcoming Assignments / Quiz
              </p>
            </div>

            <div className="assignment-body">
              {getUpcomingAnnoucements?.length > 0 ? (
                getUpcomingAnnoucements?.map((item, index) =>
                  item?.StudentMarks?.map((data, i) => (
                    <div className="assignment-pill" key={i}>
                      <div className="assignment-type">
                        <p>{data.Assignment?.name}</p>
                        <span
                          className={`${
                            data.Assignment?.isQuiz ? "green-pill" : ""
                          }`}
                        >
                          {data.Assignment?.isQuiz ? "Quiz" : "General"}
                        </span>
                      </div>
                      {
                        data.Assignment.assignmentType === 'course' ? 
                        <Button
                          children={"View"}
                          classname={"darkBtn"}
                          isdisabled={false}
                          onClick={() =>
                            navigate(`/courseAssignment`)
                          }
                        />:
                        <Button
                          children={"View"}
                          classname={"darkBtn"}
                          isdisabled={false}
                          onClick={() =>
                            navigate(`/courseDetails?courseId=${data?.courseId}`)
                          }
                        />
                      }
                    </div>
                  ))
                )
              ) : (
                <div className="assignment-type">
                  <p>No Upcoming Assignments / Quiz</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="dashboard-right">
          <div className="top-wrapper">
            <div className="assignment-wrapper attendance-wrapper">
              <div className="process-heading flexbox">
                <p className="dash-heading-small">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.49996 3.95833C6.23431 3.95833 5.20829 4.98434 5.20829 6.24999C5.20829 7.51565 6.23431 8.54166 7.49996 8.54166C8.76561 8.54166 9.79163 7.51565 9.79163 6.24999C9.79163 4.98434 8.76561 3.95833 7.49996 3.95833ZM3.95829 6.24999C3.95829 4.29399 5.54395 2.70833 7.49996 2.70833C9.45597 2.70833 11.0416 4.29399 11.0416 6.24999C11.0416 8.206 9.45597 9.79166 7.49996 9.79166C5.54395 9.79166 3.95829 8.206 3.95829 6.24999ZM15.8333 2.70833C16.1785 2.70833 16.4583 2.98815 16.4583 3.33333V5.20833H18.3333C18.6785 5.20833 18.9583 5.48815 18.9583 5.83333C18.9583 6.17851 18.6785 6.45833 18.3333 6.45833H16.4583V8.33333C16.4583 8.67851 16.1785 8.95833 15.8333 8.95833C15.4881 8.95833 15.2083 8.67851 15.2083 8.33333V6.45833H13.3333C12.9881 6.45833 12.7083 6.17851 12.7083 5.83333C12.7083 5.48815 12.9881 5.20833 13.3333 5.20833H15.2083V3.33333C15.2083 2.98815 15.4881 2.70833 15.8333 2.70833ZM5.63986 11.875H9.36006C10.0374 11.875 10.5838 11.875 11.0262 11.9111C11.4817 11.9483 11.8818 12.027 12.252 12.2156C12.84 12.5152 13.3181 12.9933 13.6177 13.5813C13.8063 13.9515 13.8849 14.3516 13.9222 14.8071C13.9583 15.2495 13.9583 15.7959 13.9583 16.4732V17.5C13.9583 17.8452 13.6785 18.125 13.3333 18.125C12.9881 18.125 12.7083 17.8452 12.7083 17.5V16.5C12.7083 15.7896 12.7078 15.2944 12.6763 14.9089C12.6454 14.5307 12.5878 14.3134 12.5039 14.1488C12.3242 13.796 12.0373 13.5091 11.6845 13.3294C11.5199 13.2455 11.3026 13.1879 10.9244 13.157C10.5389 13.1255 10.0437 13.125 9.33329 13.125H5.66663C4.95625 13.125 4.46105 13.1255 4.07553 13.157C3.6973 13.1879 3.47999 13.2455 3.31539 13.3294C2.96259 13.5091 2.67575 13.796 2.49599 14.1488C2.41212 14.3134 2.35451 14.5307 2.32361 14.9089C2.29211 15.2944 2.29163 15.7896 2.29163 16.5V17.5C2.29163 17.8452 2.0118 18.125 1.66663 18.125C1.32145 18.125 1.04163 17.8452 1.04163 17.5L1.04163 16.4732C1.04162 15.7959 1.04161 15.2495 1.07776 14.8071C1.11498 14.3516 1.19361 13.9515 1.38223 13.5813C1.68184 12.9933 2.1599 12.5152 2.74791 12.2156C3.11809 12.027 3.51821 11.9483 3.97374 11.9111C4.41616 11.875 4.9625 11.875 5.63986 11.875Z"
                      fill="black"
                    />
                  </svg>
                  Attendance
                </p>
                <div className="primaryTag">
                  Total Attendance:{" "}
                  {getStudentCourseAttendance?.AttendancePercentage === null
                    ? 0
                    : getStudentCourseAttendance?.AttendancePercentage?.toFixed(
                        2
                      )}
                  %
                </div>
              </div>

              <div className="assignment-body">
                {getStudentCourseAttendance?.Data?.length > 0 &&
                  getStudentCourseAttendance?.Data?.map((res, i) => (
                    <div className="assignment-pill" key={i}>
                      <div className="assignment-type">
                        <p>{res.courseName}</p>
                        <p className="text-4">{getPercentage(res)}%</p>
                        <ProgressBar
                          width={`${getPercentage(res)}%`}
                          color={"var(--primary-4)"}
                        />
                      </div>
                    </div>
                  ))}

                {/* <div className="assignment-pill">
                  <div className="assignment-type">
                    <p>Building Marketing Strategies</p>
                    <p className="text-4">50%</p>
                    <ProgressBar width={"50%"} color={"var(--primary-4)"} />
                  </div>
                </div> */}

                {/* <div className="assignment-pill">
                  <div className="assignment-type">
                    <p>Building Marketing Strategies</p>
                    <p className="text-4">50%</p>
                    <ProgressBar width={"20%"} color={"var(--primary-4)"} />
                  </div>
                </div> */}
              </div>
            </div>

            <div className="assignment-wrapper announcement-wrapper">
              <div className="process-heading">
                <div className="d-flex">
                  <p className="dash-heading-small">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.50004 19C6.33337 19 6.25004 19 6.16671 19C5.25004 18.9167 4.50004 18.3333 4.16671 17.4167C4.16671 17.3333 4.08337 17.25 4.08337 17.0833L2.75004 11.8333C2.75004 11.8333 2.75004 11.8333 2.75004 11.75C1.75004 10.9167 1.08337 9.66666 1.08337 8.33333C1.08337 5.91666 3.08337 3.99999 5.41671 3.99999H8.58337C9.66671 3.99999 11.1667 3.49999 12.9167 2.49999C13.8334 1.99999 14.3334 1.74999 14.75 1.83333C15.1667 1.91666 15.5 2.08333 15.75 2.41666C16 2.83333 16 3.24999 16 4.33333V4.91666C17.6667 5.24999 18.9167 6.66666 18.9167 8.41666C18.9167 10.1667 17.6667 11.5833 16 11.9167V12.5C16 13.5 16 14 15.75 14.4167C15.5 14.75 15.1667 15 14.75 15C14.25 15.0833 13.8334 14.8333 12.9167 14.3333C11.3334 13.5 10 13 9.00004 12.9167V16.6667C9.00004 16.9167 9.00004 17 9.00004 17.0833C8.91671 18.1667 8.00004 19 6.91671 19.1667C6.83337 18.9167 6.66671 19 6.50004 19ZM6.50004 17.6667C6.66671 17.6667 6.75004 17.6667 6.83337 17.6667C7.33337 17.5833 7.75004 17.25 7.75004 16.75C7.75004 16.6667 7.75004 16.5833 7.75004 16.4167V12.6667H5.41671C5.00004 12.6667 4.58337 12.5833 4.16671 12.5L5.25004 16.75C5.25004 16.9167 5.33337 16.9167 5.33337 17C5.50004 17.4167 5.83337 17.6667 6.25004 17.6667C6.25004 17.75 6.33337 17.6667 6.50004 17.6667ZM9.00004 11.5C10.25 11.5833 11.75 12.1667 13.5834 13.0833C14.0834 13.3333 14.5834 13.5833 14.75 13.6667C14.75 13.6667 14.8334 13.6667 14.8334 13.5833C14.8334 13.5 14.8334 13 14.8334 12.4167V4.24999C14.8334 3.66666 14.8334 3.16666 14.75 3.08333C14.75 3.08333 14.6667 2.99999 14.5834 2.99999C14.5 2.99999 14 3.24999 13.5 3.58333C11.75 4.58333 10.1667 5.08333 8.91671 5.16666V11.5H9.00004ZM5.41671 5.16666C3.66671 5.16666 2.33337 6.58333 2.33337 8.33333C2.33337 10.0833 3.75004 11.5 5.50004 11.5H7.83337V5.16666H5.41671ZM16 6.16666V10.5833C17 10.3333 17.6667 9.41666 17.6667 8.41666C17.6667 7.41666 17 6.41666 16 6.16666Z"
                        fill="#262626"
                      />
                    </svg>
                    Announcements
                    <span className="notification-dot">
                      {announcementData?.length}
                    </span>
                  </p>

                  {/* <p onClick={()=>navigate("/announcement")}>View All</p> */}
                  <Button
                    onClick={() => navigate("/announcement")}
                    children={"View All"}
                    classname={"primaryBtn"}
                    isdisabled={false}
                  />
                </div>
              </div>

              <div className="assignment-body">
                {announcementData?.length > 0 &&
                  announcementData?.slice(0, 3)?.map((val, index) => (
                    <div className="assignment-pill">
                      <div className="assignment-type" key={index}>
                        <p>
                          {announcementData &&
                            removeTags(val?.announcementDescription)}
                        </p>
                        <span className="green-pill">
                          {val?.announcementType}
                        </span>
                      </div>
                      <Button
                        onClick={() => handleAnnouncmentClick(index)}
                        children={"View"}
                        classname={"primaryBtn"}
                        isdisabled={false}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="bottom-wrapper mt-10">
            <div className="event-left">
              <div className="upper-event-list">
                <p className="category-text">Category of Events</p>
                {getStudentCourseData?.length > 0 &&
                  getStudentCourseData?.map((res, i) => (
                    <label class="custom-chk-box green-box mt-10">
                      {res?.CourseRoster?.courseName}
                      <input
                        type="checkbox"
                        name="category"
                        id={i}
                        value={res.CourseRoster.id}
                        onChange={categoryHandleChange}
                        // checked={category[] === res.CourseRoster.id}
                        checked={
                          category.includes(res.CourseRoster.id) ? true : false
                        }
                      />
                      <span class="checkmark"></span>
                    </label>
                  ))}

                {/* // <label class="custom-chk-box mt-10 green-box">yellow-box
                //   Career Event
                //   <input type="checkbox" id="check-one" />
                //   <span class="checkmark"></span>
                // </label>

                // <label class="custom-chk-box mt-10 red-box">
                //   Engagement Event
                //   <input type="checkbox" id="check-one" />
                //   <span class="checkmark"></span>
                // </label> */}
              </div>

              {/* <span className="divider"></span>

              <div className="upper-event-list meeting-list mt-20">
                <p className="category-text">
                  Add Meeting
                  <div className="icon-box-meeting">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.99996 3.54167C10.3451 3.54167 10.625 3.82149 10.625 4.16667V9.375H15.8333C16.1785 9.375 16.4583 9.65483 16.4583 10C16.4583 10.3452 16.1785 10.625 15.8333 10.625H10.625V15.8333C10.625 16.1785 10.3451 16.4583 9.99996 16.4583C9.65478 16.4583 9.37496 16.1785 9.37496 15.8333V10.625H4.16663C3.82145 10.625 3.54163 10.3452 3.54163 10C3.54163 9.65483 3.82145 9.375 4.16663 9.375H9.37496V4.16667C9.37496 3.82149 9.65478 3.54167 9.99996 3.54167Z"
                        fill="#171717"
                      />
                    </svg>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.4419 12.9419C15.1979 13.186 14.8021 13.186 14.5581 12.9419L10 8.38388L5.44194 12.9419C5.19786 13.186 4.80214 13.186 4.55806 12.9419C4.31398 12.6979 4.31398 12.3021 4.55806 12.0581L9.55806 7.05806C9.80214 6.81398 10.1979 6.81398 10.4419 7.05806L15.4419 12.0581C15.686 12.3021 15.686 12.6979 15.4419 12.9419Z"
                        fill="#171717"
                      />
                    </svg>
                  </div>
                </p>

                <div className="meet-icon-list">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="36" height="36" rx="8" fill="#D9E9F9" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.9167 11.125C14.1908 11.125 12.7917 12.5241 12.7917 14.25C12.7917 15.9759 14.1908 17.375 15.9167 17.375C17.6425 17.375 19.0417 15.9759 19.0417 14.25C19.0417 12.5241 17.6425 11.125 15.9167 11.125ZM11.5417 14.25C11.5417 11.8338 13.5004 9.875 15.9167 9.875C18.3329 9.875 20.2917 11.8338 20.2917 14.25C20.2917 16.6662 18.3329 18.625 15.9167 18.625C13.5004 18.625 11.5417 16.6662 11.5417 14.25ZM20.7736 10.6117C20.9272 10.3025 21.3024 10.1765 21.6115 10.3301C23.0505 11.0452 24.0417 12.5313 24.0417 14.25C24.0417 15.9687 23.0505 17.4548 21.6115 18.1699C21.3024 18.3235 20.9272 18.1975 20.7736 17.8883C20.62 17.5792 20.7461 17.2041 21.0552 17.0505C22.0857 16.5384 22.7917 15.4761 22.7917 14.25C22.7917 13.0239 22.0857 11.9616 21.0552 11.4495C20.7461 11.2959 20.62 10.9208 20.7736 10.6117ZM15.9167 21.9583C13.7235 21.9583 11.6894 23.1039 10.1581 25.0528C9.94485 25.3242 9.55194 25.3714 9.28052 25.1581C9.0091 24.9449 8.96194 24.552 9.1752 24.2805C10.8881 22.1004 13.2584 20.7083 15.9167 20.7083C18.5749 20.7083 20.9452 22.1004 22.6581 24.2805C22.8714 24.552 22.8242 24.9449 22.5528 25.1581C22.2814 25.3714 21.8885 25.3242 21.6752 25.0528C20.1439 23.1039 18.1098 21.9583 15.9167 21.9583ZM22.4306 21.7143C22.5729 21.3998 22.9432 21.2603 23.2577 21.4026C24.6212 22.0196 25.8322 23.0173 26.8248 24.2805C27.038 24.552 26.9909 24.9449 26.7195 25.1581C26.448 25.3714 26.0551 25.3242 25.8419 25.0528C24.9553 23.9244 23.8978 23.0643 22.7423 22.5414C22.4278 22.3991 22.2883 22.0288 22.4306 21.7143Z"
                      fill="#006CD4"
                    />
                  </svg>

                  <div className="meet-text">
                    <p className="meet-heading">Coaching Session 1</p>
                    <p className="meet-description">10:30 - 10:45 AM</p>
                  </div>
                </div>

                <div className="meet-icon-list mt-10">
                  <svg
                    width="36"
                    height="37"
                    viewBox="0 0 36 37"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="0.5"
                      width="36"
                      height="36"
                      rx="8"
                      fill="#D9E9F9"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.6667 9.54166C15.0118 9.54166 15.2917 9.82148 15.2917 10.1667V11.2083H20.7083V10.1667C20.7083 9.82148 20.9882 9.54166 21.3333 9.54166C21.6785 9.54166 21.9583 9.82148 21.9583 10.1667V11.2087C22.4413 11.2101 22.8486 11.2163 23.1929 11.2445C23.6484 11.2817 24.0485 11.3603 24.4187 11.5489C25.0067 11.8485 25.4848 12.3266 25.7844 12.9146C25.973 13.2848 26.0516 13.6849 26.0889 14.1404C26.125 14.5829 26.125 15.1292 26.125 15.8066V22.8601C26.125 23.5375 26.125 24.0838 26.0889 24.5262C26.0516 24.9817 25.973 25.3819 25.7844 25.752C25.4848 26.34 25.0067 26.8181 24.4187 27.1177C24.0485 27.3063 23.6484 27.385 23.1929 27.4222C22.7505 27.4583 22.2041 27.4583 21.5268 27.4583H14.4732C13.7959 27.4583 13.2495 27.4583 12.8071 27.4222C12.3516 27.385 11.9515 27.3063 11.5813 27.1177C10.9933 26.8181 10.5152 26.34 10.2156 25.752C10.027 25.3819 9.94835 24.9817 9.91114 24.5262C9.87499 24.0838 9.87499 23.5374 9.875 22.8601V15.8066C9.87499 15.1292 9.87499 14.5829 9.91114 14.1404C9.94835 13.6849 10.027 13.2848 10.2156 12.9146C10.5152 12.3266 10.9933 11.8485 11.5813 11.5489C11.9515 11.3603 12.3516 11.2817 12.8071 11.2445C13.1514 11.2163 13.5587 11.2101 14.0417 11.2087V10.1667C14.0417 9.82148 14.3215 9.54166 14.6667 9.54166ZM14.0417 12.4588C13.5671 12.4602 13.2055 12.4661 12.9089 12.4903C12.5307 12.5212 12.3134 12.5788 12.1488 12.6627C11.796 12.8424 11.5091 13.1293 11.3294 13.4821C11.2455 13.6467 11.1879 13.864 11.157 14.2422C11.1255 14.6277 11.125 15.1229 11.125 15.8333V16.2083H24.875V15.8333C24.875 15.1229 24.8745 14.6277 24.843 14.2422C24.8121 13.864 24.7545 13.6467 24.6706 13.4821C24.4909 13.1293 24.204 12.8424 23.8512 12.6627C23.6866 12.5788 23.4693 12.5212 23.0911 12.4903C22.7945 12.4661 22.4329 12.4602 21.9583 12.4588V13.5C21.9583 13.8452 21.6785 14.125 21.3333 14.125C20.9882 14.125 20.7083 13.8452 20.7083 13.5V12.4583H15.2917V13.5C15.2917 13.8452 15.0118 14.125 14.6667 14.125C14.3215 14.125 14.0417 13.8452 14.0417 13.5V12.4588ZM24.875 17.4583H11.125V22.8333C11.125 23.5437 11.1255 24.0389 11.157 24.4244C11.1879 24.8027 11.2455 25.02 11.3294 25.1846C11.5091 25.5374 11.796 25.8242 12.1488 26.004C12.3134 26.0878 12.5307 26.1454 12.9089 26.1763C13.2944 26.2078 13.7896 26.2083 14.5 26.2083H21.5C22.2104 26.2083 22.7056 26.2078 23.0911 26.1763C23.4693 26.1454 23.6866 26.0878 23.8512 26.004C24.204 25.8242 24.4909 25.5374 24.6706 25.1846C24.7545 25.02 24.8121 24.8027 24.843 24.4244C24.8745 24.0389 24.875 23.5437 24.875 22.8333V17.4583Z"
                      fill="#006CD4"
                    />
                  </svg>

                  <div className="meet-text">
                    <p className="meet-heading">Team Members</p>
                    <p className="meet-description">11:30 - 12:45 PM</p>
                  </div>
                </div>
              </div> */}
            </div>

            <Calendar
              localizer={localizer}
              events={eventList}
              startAccessor="start"
              endAccessor="end"
              defaultView="week"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashBoard;
